import { Injectable, signal, computed } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { UserSettings } from '../models/UserSettings';
import { UserRoleIdEnum } from '../models/Enums';

@Injectable({ providedIn: 'root' })
export class UserSettingsService {
    private useDefaultFiltersSubject = new BehaviorSubject<boolean>(true);
    useDefaultFilters$ = this.useDefaultFiltersSubject.asObservable();

    private userSettings = signal<UserSettings | null>(null);
    isScaleOperator = computed(() => this.userSettings()?.userRole === UserRoleIdEnum.ScaleOperator);

    private compuweighEnabled = signal<boolean>(false);
    isCompuweighEnabledForCurrentTU = computed(() => this.compuweighEnabled());

    setUserSettings(settings: UserSettings): void {
        this.userSettings.set(settings);
    }

    getUserSettings(): UserSettings | null {
        return this.userSettings();
    }

    setCompuweighEnabled(value: boolean): void {
        this.compuweighEnabled.set(value);
    }

    readonly locCodeChanged$ = new Subject<string>();

    setCurrentLocCode(locCode: string): void {
        sessionStorage.setItem('locCode', locCode);
        this.locCodeChanged$.next(locCode);
    }

    setUseDefaultFilters(value: boolean) {
        this.useDefaultFiltersSubject.next(value);
    }

    getUseDefaultFilters(): boolean {
        return this.useDefaultFiltersSubject.getValue();
    }
}
